import React from 'react';
import { AboutUsData } from "../../constants/index";
import { useStateContext } from '../../context/ContextProvider';
import GradiantButton from '../layout/GradiantButton';
import {IoIosArrowBack,IoIosArrowForward} from "../icons"
import { Link } from 'react-router-dom';
const AboutUs = () => {
  const { currentLang } = useStateContext();

  
  

  return (
    <div className={`mt-12  md:mt-16 lg:mt-20   `}>
      <div className="rounded-3xl container backdrop-blur-sm bg-gradient-to-b from-light-glass1 to-light-glass2 dark:from-dark-glass1 dark:to-dark-glass2 border border-light-glassStrock2 dark:border-dark-glassStrock1 shadow-xl p-6 md:p-8 lg:p-10">
        
        <div className="flex flex-col lg:flex-row items-center justify-between gap-8 md:gap-10 lg:gap-12">
          
          <div className="flex-1 space-y-8 md:space-y-10 md:max-w-[50%]">
            <div className="space-y-4">
              <h2 className="h3 text-light-blue dark:text-dark-title">
                {currentLang === "ar" ? AboutUsData.Main_title_Ar : AboutUsData.Main_title_En}
              </h2>
              <p className="body-1 leading-relaxed text-light-text dark:text-dark-text">
                {currentLang === "ar" ? AboutUsData.Main_description_Ar : AboutUsData.Main_description_En}
              </p>
            </div>

   
          </div>

          <div className="flex-shrink-0 mt-8 lg:mt-0">
            <div className="relative">
           
              <img 
                src={AboutUsData.image} 
                alt="About Us" 
                className="relative w-64 h-64 md:w-80 md:h-80 lg:w-full lg:h-96 object-contain z-10"
              />
            </div>
          </div>
        </div>

        <div className={`mt-10 md:mt-12 flex  justify-start`}>
          <Link to="/AboutUs"
              onClick={() => {
                window.scrollTo(0, 0);
              }}
          >
        <GradiantButton textSize={""} text=  {currentLang === "ar" ? AboutUsData.buttonText_Ar : AboutUsData.buttonText_En} icon={currentLang === "en" ? <IoIosArrowForward size={20} /> : <IoIosArrowBack size={20}/>} />
          
        </Link>
        </div>
      
      </div>

 
    </div>
  );
};


 
export function WCard() {
    const { currentLang } = useStateContext();
    const isRTL = currentLang === "ar";
  return (
    <div className="mt-4 md:mt-6 lg:mt-10 flex flex-wrap md:flex-nowrap gap-3 md:gap-5 xl:gap-7">
      <div
        className={` p-4 rounded-xl bg-gradient-to-b from-light-glass1 to-light-glass2 dark:from-dark-glass1 dark:to-dark-glass2
        ${isRTL ? 'border-r-4 pr-4 md:pr-5' : 'border-l-4 pl-4 md:pl-5'} border-light-link dark:border-dark-link `}
      >
    
        <h3 className="text-xl md:text-2xl h4  mb-3 text-light-blue dark:text-dark-title">
                {currentLang === "ar" ? AboutUsData.Third_title_Ar : AboutUsData.Third_title_En}
              </h3>
              <p className="body-1 text-light-text dark:text-dark-text">
                {currentLang === "ar" ? AboutUsData.Third_description_Ar : AboutUsData.Third_description_En}
              </p>

      
      </div>
      <div 
         className={`p-4 bg-gradient-to-b rounded-xl from-light-glass1 to-light-glass2 dark:from-dark-glass1 dark:to-dark-glass2 ${isRTL ? 'border-r-4 pr-4 md:pr-5' : 'border-l-4 pl-4 md:pl-5'} border-light-link dark:border-dark-link `}
      >
      <h3 className="text-xl md:text-2xl h4 mb-3 text-light-blue dark:text-dark-title">
                {currentLang === "ar" ? AboutUsData.Second_title_Ar : AboutUsData.Second_title_En}
              </h3>
              <p className="text-base md:text-lg font-kufi text-light-subtitle dark:text-dark-subtitle">
                {currentLang === "ar" ? AboutUsData.second_description_Ar : AboutUsData.second_description_En}
              </p>
      </div>
  
    </div>
  );
}






export default AboutUs;